// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function UnorderedList(Props) {
  var list = Props.list;
  return React.createElement("ul", {
              className: "c-unordered-list-container"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.map((function (li) {
                        return React.createElement("li", {
                                    key: li
                                  }, li);
                      }), list)));
}

var make = UnorderedList;

export {
  make ,
  
}
/* react Not a pure module */
